import React, { useState, useRef, useEffect } from 'react';
import './Hero.css';
import ContactApp from './programs/ContactApp';
import { openDeckPage } from '../openDeck';

// 10 Micro Machines style vehicles — 10 cols × 5 rows, side view
// Frame 2 animates wheels/tracks for a rolling effect
const VEHICLES = [
  // 1 — Race car
  { f1: [[0,0,0,1,1,1,0,0,0,0],[0,0,0,1,0,1,1,1,0,0],[1,1,1,1,1,1,1,1,1,0],[1,1,1,1,1,1,1,1,1,0],[0,1,1,0,0,0,1,1,0,0]],
    f2: [[0,0,0,1,1,1,0,0,0,0],[0,0,0,1,0,1,1,1,0,0],[1,1,1,1,1,1,1,1,1,0],[1,1,1,1,1,1,1,1,1,0],[0,1,0,1,0,0,1,0,1,0]] },

  // 2 — Dump truck
  { f1: [[1,1,0,0,1,1,1,1,0,0],[1,1,0,0,0,1,1,1,0,0],[1,1,1,1,1,1,1,1,1,0],[1,1,1,1,1,1,1,1,1,0],[0,1,1,0,0,0,1,1,0,0]],
    f2: [[1,1,0,0,1,1,1,1,0,0],[1,1,0,0,0,1,1,1,0,0],[1,1,1,1,1,1,1,1,1,0],[1,1,1,1,1,1,1,1,1,0],[0,1,0,1,0,0,1,0,1,0]] },

  // 3 — Bulldozer (blade on front/right side)
  { f1: [[0,1,1,0,0,0,0,0,0,0],[0,1,1,0,0,0,0,0,0,0],[1,1,1,1,1,1,1,1,0,1],[1,1,1,1,1,1,1,1,0,1],[0,1,1,1,1,1,1,0,0,0]],
    f2: [[0,1,1,0,0,0,0,0,0,0],[0,1,1,0,0,0,0,0,0,0],[1,1,1,1,1,1,1,1,0,1],[1,1,1,1,1,1,1,1,0,1],[1,0,1,1,1,1,0,1,0,0]] },

  // 4 — Hover / sci-fi pod
  { f1: [[0,0,1,1,1,1,1,0,0,0],[0,1,1,1,1,1,1,1,0,0],[1,1,1,1,1,1,1,1,1,0],[0,1,1,1,1,1,1,1,0,0],[0,0,1,0,0,0,1,0,0,0]],
    f2: [[0,0,1,1,1,1,1,0,0,0],[0,1,1,1,1,1,1,1,0,0],[1,1,1,1,1,1,1,1,1,0],[0,1,1,1,1,1,1,1,0,0],[0,1,0,0,0,0,0,1,0,0]] },

  // 5 — Monster truck
  { f1: [[0,0,1,1,1,1,0,0,0,0],[0,1,1,1,1,1,1,0,0,0],[1,1,1,1,1,1,1,1,0,0],[1,1,1,1,1,1,1,1,0,0],[1,0,1,0,0,0,1,0,1,0]],
    f2: [[0,0,1,1,1,1,0,0,0,0],[0,1,1,1,1,1,1,0,0,0],[1,1,1,1,1,1,1,1,0,0],[1,1,1,1,1,1,1,1,0,0],[0,1,0,1,0,1,0,1,0,0]] },

  // 6 — Forklift (forks on leading side)
  { f1: [[1,0,0,1,1,0,0,0,0,0],[1,0,0,1,1,1,0,0,0,0],[1,0,0,1,1,1,1,0,0,0],[1,1,1,1,1,1,1,0,0,0],[0,1,1,0,0,1,1,0,0,0]],
    f2: [[1,0,0,1,1,0,0,0,0,0],[1,0,0,1,1,1,0,0,0,0],[1,0,0,1,1,1,1,0,0,0],[1,1,1,1,1,1,1,0,0,0],[1,0,1,0,0,1,0,1,0,0]] },

  // 7 — Tank
  { f1: [[0,0,1,0,0,0,0,0,0,0],[0,1,1,1,1,0,0,0,0,0],[1,1,1,1,1,1,1,1,0,0],[1,1,1,1,1,1,1,1,0,0],[0,1,1,1,1,1,1,0,0,0]],
    f2: [[0,0,1,0,0,0,0,0,0,0],[0,1,1,1,1,0,0,0,0,0],[1,1,1,1,1,1,1,1,0,0],[1,1,1,1,1,1,1,1,0,0],[1,0,1,1,1,1,0,1,0,0]] },

  // 8 — Van / mini bus
  { f1: [[0,1,1,1,1,1,1,1,0,0],[0,1,0,1,0,1,0,1,0,0],[1,1,1,1,1,1,1,1,1,0],[1,1,1,1,1,1,1,1,1,0],[0,1,1,0,0,0,0,1,1,0]],
    f2: [[0,1,1,1,1,1,1,1,0,0],[0,1,0,1,0,1,0,1,0,0],[1,1,1,1,1,1,1,1,1,0],[1,1,1,1,1,1,1,1,1,0],[0,1,0,1,0,0,1,0,1,0]] },

  // 9 — Excavator with extended arm
  { f1: [[0,0,0,0,0,0,0,1,1,1],[0,0,0,0,0,0,1,1,0,0],[0,0,1,1,1,1,0,0,0,0],[1,1,1,1,1,1,1,0,0,0],[0,1,1,1,1,1,0,0,0,0]],
    f2: [[0,0,0,0,0,0,1,1,1,0],[0,0,0,0,0,1,1,0,0,0],[0,0,1,1,1,1,0,0,0,0],[1,1,1,1,1,1,1,0,0,0],[1,0,1,1,1,0,1,0,0,0]] },

  // 10 — Rocket car (exhaust trail animates)
  { f1: [[0,0,1,1,0,0,0,0,0,0],[1,0,1,1,1,1,1,1,1,0],[1,0,1,1,1,1,1,1,1,0],[0,0,0,1,1,1,1,0,0,0],[0,0,0,1,1,0,1,1,0,0]],
    f2: [[0,0,1,1,0,0,0,0,0,0],[1,1,1,1,1,1,1,1,1,0],[1,1,1,1,1,1,1,1,1,0],[0,0,0,1,1,1,1,0,0,0],[0,0,0,1,0,1,1,0,1,0]] },
];

const P    = 2;   // px per pixel
const COLS = 10;
const ROWS = 5;
const VW   = COLS * P;  // vehicle width  = 20px
const VH   = ROWS * P;  // vehicle height = 10px
const GAP  = 5;
const AXIS_THRESHOLD = 15;
const PUSH_EASING    = 'cubic-bezier(0.33, 1, 0.68, 1)';
const PUSH_DURATION  = 1100; // ms — must match .hero-panel-returning transition
const DRIVE_DURATION = 5000; // ms — entry/exit drive speed (stepped/mechanical)

// Retro pixel-art vehicle color palette
const COLORS = [
  '#ff3333', // red
  '#ffcc00', // yellow
  '#ff8800', // orange
  '#00ff88', // lime
  '#00ccff', // cyan
  '#aa44ff', // violet
  '#ff44cc', // pink
  '#ffffff', // white
];

function PixelSprite({ vehicle, frame, color }) {
  const grid = frame === 2 ? vehicle.f2 : vehicle.f1;
  return (
    <svg width={COLS * P} height={ROWS * P} style={{ display: 'block', imageRendering: 'pixelated' }}>
      {grid.flatMap((row, r) =>
        row.map((on, c) =>
          on ? <rect key={`${r}-${c}`} x={c * P} y={r * P} width={P} height={P} fill={color} /> : null
        )
      )}
    </svg>
  );
}

function Vehicle({ direction, enterTarget, pushTarget, phase, vehicleIndex, color }) {
  const [frame, setFrame]            = useState(1);
  const [left, setLeft]              = useState(enterTarget.left);
  const [top,  setTop]               = useState(enterTarget.top);
  const [posTransition, setPosTrans] = useState('none');

  // Walk/roll cycle — freeze on frame 2 during push
  useEffect(() => {
    if (phase === 'pushing') return;
    const id = setInterval(() => setFrame(f => (f === 1 ? 2 : 1)), 600);
    return () => clearInterval(id);
  }, [phase]);

  // Sync position with phase
  useEffect(() => {
    if (phase === 'entering') {
      setPosTrans('none');
      setLeft(enterTarget.left);
      setTop(enterTarget.top);
    } else if (phase === 'pushing') {
      setPosTrans(`left ${PUSH_DURATION}ms ${PUSH_EASING}, top ${PUSH_DURATION}ms ${PUSH_EASING}`);
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          setLeft(pushTarget.left);
          setTop(pushTarget.top);
        })
      );
    } else if (phase === 'exiting') {
      setPosTrans('none');
      setLeft(pushTarget.left);
      setTop(pushTarget.top);
    }
  }, [phase]); // eslint-disable-line react-hooks/exhaustive-deps

  const spriteTransform = {
    left:   'none',
    right:  'scaleX(-1)',
    top:    'rotate(90deg)',
    bottom: 'rotate(-90deg)',
  }[direction];

  return (
    <div
      className={`pixel-vehicle pixel-vehicle-${direction} vehicles-${phase}`}
      style={{ left, top, transition: posTransition }}
    >
      <div style={{ transform: spriteTransform }}>
        <PixelSprite vehicle={VEHICLES[vehicleIndex]} frame={frame} color={color} />
      </div>
    </div>
  );
}

function buildVehicles(pos, rect) {
  const list = [];

  if (Math.abs(pos.x) > AXIS_THRESHOLD) {
    const dir       = pos.x < 0 ? 'left' : 'right';
    const enterLeft = dir === 'left' ? rect.left - VW - GAP : rect.right + GAP;
    const pushLeft  = dir === 'left'
      ? rect.left - pos.x - VW - GAP
      : rect.right - pos.x + GAP;

    list.push({
      id: 'h', direction: dir,
      vehicleIndex: Math.floor(Math.random() * VEHICLES.length),
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      enterTarget: { left: enterLeft, top: rect.top + rect.height / 2 - VH / 2 },
      pushTarget:  { left: pushLeft,  top: rect.top - pos.y + rect.height / 2 - VH / 2 },
    });
  }

  if (Math.abs(pos.y) > AXIS_THRESHOLD) {
    const dir      = pos.y < 0 ? 'top' : 'bottom';
    const enterTop = dir === 'top' ? rect.top - VW - GAP : rect.bottom + GAP;
    const pushTop  = dir === 'top'
      ? rect.top - pos.y - VW - GAP
      : rect.bottom - pos.y + GAP;

    list.push({
      id: 'v', direction: dir,
      vehicleIndex: Math.floor(Math.random() * VEHICLES.length),
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      enterTarget: { left: rect.left + rect.width / 2 - VH / 2, top: enterTop },
      pushTarget:  { left: rect.left - pos.x + rect.width / 2 - VH / 2, top: pushTop },
    });
  }

  return list;
}

// ─── STATEMENTS (cycling typewriter titles) ───────────────────────────────────
const STATEMENTS = [
  "Helping businesses\nmove forward with AI.",
  "Turning AI potential\ninto real outcomes.",
  "From strategy\nto deployment.",
  "AI integrations\nyour team actually uses.",
  "Bridging the gap\nbetween humans and AI.",
  "Making AI work\nfor your business.",
];
// Longest statement — reserves h1 height so panel never resizes
const SPACER = "AI integrations\nyour team actually uses.";

// ─── TERMINAL APP REGISTRY ───────────────────────────────────────────────────
// ─── HELP TEXT ───────────────────────────────────────────────────────────────
// Shown above the $_ cursor when the user types 'help'.
const HELP_TEXT =
`commands:
  center      call robots to center the panel
  reboot      restart to boot_main
  contact     open contact form`;

const ORACULUS_HELP_TEXT =
`commands:
  back        return to previous app
  reboot      restart to boot_main
  contact     open contact form`;

// ─── TERMINAL APP REGISTRY ───────────────────────────────────────────────────
// Spec fields:
//   path        — title bar path shown while the terminal app is active
//   cmd         — boot command typed out character by character
//   type        — layout template:
//                   'dynamic_text' cycling title, heading font, h1 spacer
//                   'terminal'     monospace output lines, hero-app-body
//   aspectRatio — 'default' = matches boot_main panel height (510px hero-content)
//   typography  — primary font family used inside the terminal app body
//   media       — media types the terminal app may render
const TERMINAL_APPS = {
  boot_main: {
    path:        '/home/boot_main',
    cmd:         'node ai-adoption-partner.js',
    type:        'dynamic_text',
    aspectRatio: 'default',
    typography:  'sans-serif',
    media:       ['text'],
  },
  oraculus: {
    path:        '/home/oraculus',
    cmd:         'node oraculus.js',
    type:        'terminal',
    aspectRatio: 'default',
    typography:  'monospace',
    media:       ['text'],
  },
  contact: {
    path:        '/contact_us',
    cmd:         'node contact.js',
    type:        'terminal',
    aspectRatio: 'default',
    typography:  'monospace',
    media:       ['text'],
  },
};

// ─── HEIGHT ANCHOR (shared between all terminal apps) ────────────────────────
// Renders the invisible SPACER h1 that locks the panel height.
// Terminal apps overlay their own content using position:absolute inside it.
function TitleAnchor({ children }) {
  return (
    <h1 className="hero-title" style={{ position: 'relative' }}>
      <span style={{ visibility: 'hidden', userSelect: 'none', whiteSpace: 'nowrap' }} aria-hidden="true">
        {SPACER.split('\n').map((line, i, arr) => (
          <React.Fragment key={i}>{line}{i < arr.length - 1 && <br />}</React.Fragment>
        ))}_
      </span>
      {children}
    </h1>
  );
}

// ─── TERMINAL APP: boot_main ──────────────────────────────────────────────────
function BootMain({ onCommand, onCenter, onTheme, fast = false }) {
  const CMD = TERMINAL_APPS.boot_main.cmd;
  // When fast=true (reboot), all boot timings run at 2× speed.
  // The hold time between cycling statements stays full-length.
  const s = fast ? 0.5 : 1;

  const [cmdText,         setCmdText]         = useState('');
  const [bootLine1,       setBootLine1]       = useState(false);
  const [bootLine2,       setBootLine2]       = useState(false);
  const [bootLinesOut,    setBootLinesOut]    = useState(false);
  const [displayText,     setDisplayText]     = useState('');
  const [showDescription, setShowDescription] = useState(false);
  const [showInput,       setShowInput]       = useState(false);
  const [showButtons,     setShowButtons]     = useState(false);
  const [inputText,       setInputText]       = useState('');
  const [errorLine,       setErrorLine]       = useState('');

  const [helpLine, setHelpLine] = useState('');

  const typeRef       = useRef({ idx: 0, len: 0, deleting: false, timer: null });
  const descShown     = useRef(false);
  const errorTimerRef = useRef(null);
  const helpTimerRef  = useRef(null);
  const inputRef      = useRef(null);

  useEffect(() => {
    if (showInput && inputRef.current) inputRef.current.focus({ preventScroll: true });
  }, [showInput]);

  // Boot sequence — runs once on mount. Reboot remounts via key prop in Hero.
  useEffect(() => {
    if (typeRef.current.timer) clearTimeout(typeRef.current.timer);
    typeRef.current = { idx: 0, len: 0, deleting: false, timer: null };
    descShown.current = false;

    const timers = [];
    const T = (fn, d) => { const id = setTimeout(fn, d); timers.push(id); return id; };

    const titleTick = () => {
      const st   = typeRef.current;
      const text = STATEMENTS[st.idx];
      // Speed multiplier: fast during initial boot load, normal once cycling begins
      const sp = descShown.current ? 1 : s;
      if (!st.deleting) {
        if (st.len < text.length) {
          st.len++;
          setDisplayText(text.slice(0, st.len));
          st.timer = setTimeout(titleTick, Math.round(55 * sp)); timers.push(st.timer);
        } else {
          if (!descShown.current) {
            descShown.current = true;
            T(() => setShowDescription(true), Math.round(400  * s));
            T(() => setShowButtons(true),     Math.round(900  * s));
            T(() => setShowInput(true),       Math.round(1400 * s));
          }
          st.timer = setTimeout(() => { st.deleting = true; titleTick(); }, 5000);
          timers.push(st.timer);
        }
      } else {
        if (st.len > 0) {
          st.len--;
          setDisplayText(text.slice(0, st.len));
          st.timer = setTimeout(titleTick, Math.round(28 * sp)); timers.push(st.timer);
        } else {
          st.idx = (st.idx + 1) % STATEMENTS.length;
          st.deleting = false;
          st.timer = setTimeout(titleTick, Math.round(350 * sp)); timers.push(st.timer);
        }
      }
    };

    let ci = 0;
    const cmdTick = () => {
      ci++;
      setCmdText(CMD.slice(0, ci));
      if (ci < CMD.length) T(cmdTick, Math.round(38 * s));
      else {
        T(() => setBootLine1(true),    Math.round(350  * s));
        T(() => setBootLine2(true),    Math.round(750  * s));
        T(() => setBootLinesOut(true), Math.round(2000 * s));
        T(titleTick,                   Math.round(2550 * s));
      }
    };

    T(cmdTick, Math.round(600 * s));
    return () => timers.forEach(clearTimeout);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleKey = (e) => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const raw = inputText.trim();
    const cmd = raw.toLowerCase();
    if (cmd === '') { setInputText(''); return; }
    if (cmd === 'help') {
      if (errorTimerRef.current) clearTimeout(errorTimerRef.current);
      if (helpTimerRef.current)  clearTimeout(helpTimerRef.current);
      setErrorLine('');
      setHelpLine(HELP_TEXT);
      setInputText('');
      helpTimerRef.current = setTimeout(() => setHelpLine(''), 12000);
    } else if (cmd === 'center') {
      onCenter?.();
      setInputText('');
      setErrorLine('');
      setHelpLine('');
    } else if (cmd === 'theme -ibm') {
      onTheme?.('ibm');
      setInputText('');
      setErrorLine('');
      setHelpLine('');
    } else if (cmd === 'theme -default' || cmd === 'theme -reset') {
      onTheme?.('default');
      setInputText('');
      setErrorLine('');
      setHelpLine('');
    } else if (cmd === 'deck') {
      openDeckPage();
      setInputText('');
      setErrorLine('');
      setHelpLine('');
    } else if (cmd === 'reboot' || TERMINAL_APPS[cmd]) {
      onCommand(cmd);
      setInputText('');
      setErrorLine('');
      setHelpLine('');
    } else {
      if (errorTimerRef.current) clearTimeout(errorTimerRef.current);
      if (helpTimerRef.current)  clearTimeout(helpTimerRef.current);
      setHelpLine('');
      setErrorLine(`-bash: ${raw}: command not found`);
      setInputText('');
      errorTimerRef.current = setTimeout(() => setErrorLine(''), 10000);
    }
  };

  return (
    <>
      {/* Boot sequence cmd + output lines */}
      <div className="hero-boot">
        <p className="hero-boot-cmd">
          <span className="hero-boot-prompt">$</span>{' '}{cmdText}
          {cmdText.length < CMD.length && <span className="cursor hero-boot-cur">_</span>}
        </p>
        <div className={`hero-boot-output${bootLinesOut ? ' hero-boot-output-gone' : ''}`}>
          <p className={`hero-boot-line boot-reveal${bootLine1 ? ' boot-visible' : ''}`}>
            <span className="hero-boot-arrow">↳</span> initializing...
          </p>
          <p className={`hero-boot-line boot-reveal${bootLine2 ? ' boot-visible' : ''}`}>
            <span className="hero-boot-arrow">↳</span> process running
          </p>
        </div>
      </div>

      {/* Rolling title */}
      <TitleAnchor>
        <span style={{ position: 'absolute', top: 0, left: 0, whiteSpace: 'nowrap' }}>
          {displayText.split('\n').map((line, i, arr) => (
            <React.Fragment key={i}>{line}{i < arr.length - 1 && <br />}</React.Fragment>
          ))}
        </span>
      </TitleAnchor>

      {/* Subtitle */}
      <p className={`hero-description boot-reveal${showDescription ? ' boot-visible' : ''}`}>
        In southlabs we build AI-powered products and provide strategy,<br />
        development, and integration services to accelerate your AI journey.
      </p>

      {/* CTA buttons */}
      <div className={`hero-actions boot-reveal${showButtons ? ' boot-visible' : ''}`}>
        <button
          className="btn-ghost-dim"
          onClick={() => {
            const appEl  = document.querySelector('.App');
            const target = document.getElementById('services');
            if (appEl && target) appEl.scrollTo({ top: appEl.scrollTop + target.getBoundingClientRect().top, behavior: 'smooth' });
          }}
        >Our Services</button>
        <a href="#contact" className="btn-ghost-dim">Get in Touch</a>
      </div>

      {/* Live terminal input */}
      <div className={`hero-terminal-block boot-reveal${showInput ? ' boot-visible' : ''}`}>
        {helpLine  && <pre className="hero-terminal-help">{helpLine}</pre>}
        {!helpLine && errorLine && <p className="hero-terminal-error">{errorLine}</p>}
        <div
          className="hero-terminal-input"
          onClick={() => { inputRef.current?.focus({ preventScroll: true }); setErrorLine(''); setHelpLine(''); }}
        >
          <span className="hero-boot-prompt">$</span>
          <div className="hero-terminal-input-area">
            <span className="hero-terminal-text">{inputText}</span>
            <span className="cursor hero-terminal-cur">_</span>
          </div>
          <input
            ref={inputRef}
            value={inputText}
            onChange={e => { if (e.target.value.length <= 300) setInputText(e.target.value); }}
            onKeyDown={handleKey}
            className="hero-terminal-hidden"
            autoComplete="off"
            autoCorrect="off"
            spellCheck="false"
          />
        </div>
      </div>
    </>
  );
}

// ─── TERMINAL APP: oraculus (type: terminal) ─────────────────────────────────
const ORACULUS_MSG = 'coming soon.';

const ORACULUS_LOGO = [
  '   ████████   ',
  '  ██      ██  ',
  ' ██        ██ ',
  ' ██        ██ ',
  ' ██        ██ ',
  '  ██      ██  ',
  '   ████████   ',
];

const ORACULUS_MSG_COLORS = [
  '#ff6b6b', '#ffd93d', '#6bcb77', '#4d96ff',
  '#ff922b', '#cc5de8', '#20c997', '#f06595',
];

function OraculusApp({ onCommand, prevApp }) {
  const CMD = TERMINAL_APPS.oraculus.cmd;

  const [cmdText,     setCmdText]     = useState('');
  const [logoLines,   setLogoLines]   = useState(0);
  const [msgColor,    setMsgColor]    = useState('');
  const [displayText, setDisplayText] = useState('');
  const [showInput,   setShowInput]   = useState(false);
  const [inputText,   setInputText]   = useState('');
  const [errorLine,   setErrorLine]   = useState('');
  const [helpLine,    setHelpLine]    = useState('');

  const errorTimerRef = useRef(null);
  const helpTimerRef  = useRef(null);
  const inputRef      = useRef(null);

  useEffect(() => {
    if (showInput && inputRef.current) inputRef.current.focus({ preventScroll: true });
  }, [showInput]);

  useEffect(() => {
    const timers = [];
    const T = (fn, d) => { const id = setTimeout(fn, d); timers.push(id); return id; };

    let ci = 0;
    const cmdTick = () => {
      ci++;
      setCmdText(CMD.slice(0, ci));
      if (ci < CMD.length) T(cmdTick, 38);
      else {
        let li = 0;
        const logoTick = () => {
          li++;
          setLogoLines(li);
          if (li < ORACULUS_LOGO.length) T(logoTick, 60);
          else {
            setMsgColor(ORACULUS_MSG_COLORS[Math.floor(Math.random() * ORACULUS_MSG_COLORS.length)]);
            let mi = 0;
            const msgTick = () => {
              mi++;
              setDisplayText(ORACULUS_MSG.slice(0, mi));
              if (mi < ORACULUS_MSG.length) T(msgTick, 55);
              else T(() => setShowInput(true), 600);
            };
            T(msgTick, 300);
          }
        };
        T(logoTick, 400);
      }
    };

    T(cmdTick, 300);
    return () => timers.forEach(clearTimeout);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleKey = (e) => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const raw = inputText.trim();
    const cmd = raw.toLowerCase();
    if (cmd === '') { setInputText(''); return; }
    if (cmd === 'help') {
      if (errorTimerRef.current) clearTimeout(errorTimerRef.current);
      if (helpTimerRef.current)  clearTimeout(helpTimerRef.current);
      setErrorLine('');
      setHelpLine(ORACULUS_HELP_TEXT);
      setInputText('');
      helpTimerRef.current = setTimeout(() => setHelpLine(''), 12000);
    } else if (cmd === 'back') {
      onCommand(prevApp || 'boot_main');
      setInputText('');
      setErrorLine('');
      setHelpLine('');
    } else if (cmd === 'deck') {
      openDeckPage();
      setInputText('');
      setErrorLine('');
      setHelpLine('');
    } else if (cmd === 'reboot' || TERMINAL_APPS[cmd]) {
      onCommand(cmd);
      setInputText('');
      setErrorLine('');
      setHelpLine('');
    } else {
      if (errorTimerRef.current) clearTimeout(errorTimerRef.current);
      if (helpTimerRef.current)  clearTimeout(helpTimerRef.current);
      setHelpLine('');
      setErrorLine(`-bash: ${raw}: command not found`);
      setInputText('');
      errorTimerRef.current = setTimeout(() => setErrorLine(''), 10000);
    }
  };

  return (
    <>
      {/* Boot cmd line — same structure as all terminal apps */}
      <div className="hero-boot">
        <p className="hero-boot-cmd">
          <span className="hero-boot-prompt">$</span>{' '}{cmdText}
          {cmdText.length < CMD.length && <span className="cursor hero-boot-cur">_</span>}
        </p>
      </div>

      {/* Terminal output body — clean monospace, no h1 tricks.
          min-height keeps panel the same size as boot_main. */}
      <div className="hero-app-body oraculus-app-body">
        {logoLines > 0 && (
          <div className="oraculus-logo">
            {ORACULUS_LOGO.slice(0, logoLines).map((line, i) => (
              <div key={i}>{line}</div>
            ))}
          </div>
        )}
        {displayText && (
          <p className="hero-terminal-line oraculus-msg" style={{ color: msgColor || undefined }}>
            {displayText}
            {!showInput && <span className="cursor hero-boot-cur" style={{ color: msgColor || undefined }}>_</span>}
          </p>
        )}
      </div>

      {/* Live terminal input */}
      <div className={`hero-terminal-block boot-reveal${showInput ? ' boot-visible' : ''}`}>
        {helpLine  && <pre className="hero-terminal-help">{helpLine}</pre>}
        {!helpLine && errorLine && <p className="hero-terminal-error">{errorLine}</p>}
        <div
          className="hero-terminal-input"
          onClick={() => { inputRef.current?.focus({ preventScroll: true }); setErrorLine(''); setHelpLine(''); }}
        >
          <span className="hero-boot-prompt">$</span>
          <div className="hero-terminal-input-area">
            <span className="hero-terminal-text">{inputText}</span>
            <span className="cursor hero-terminal-cur">_</span>
          </div>
          <input
            ref={inputRef}
            value={inputText}
            onChange={e => { if (e.target.value.length <= 300) setInputText(e.target.value); }}
            onKeyDown={handleKey}
            className="hero-terminal-hidden"
            autoComplete="off"
            autoCorrect="off"
            spellCheck="false"
          />
        </div>
      </div>
    </>
  );
}

// ─── TERMINAL APP COMPONENT MAP ──────────────────────────────────────────────
// Register component for each terminal app key defined in TERMINAL_APPS above.
const TERMINAL_APP_COMPONENTS = {
  boot_main: BootMain,
  oraculus:  OraculusApp,
  contact:   ContactApp,
};

// ─── Hero (shell) ─────────────────────────────────────────────────────────────
function Hero() {
  const [position,    setPosition]    = useState({ x: 0, y: 0 });
  const [isDragging,  setIsDragging]  = useState(false);
  const [isReturning, setIsReturning] = useState(false);
  const [phase,       setPhase]       = useState('hidden');
  const [vehicles,    setVehicles]    = useState([]);

  // Active terminal app + switching state
  const [activeApp,   setActiveApp]   = useState('boot_main');
  const [appInstance, setAppInstance] = useState(0);
  const [appVisible,  setAppVisible]  = useState(true);

  // Theme
  const [theme, setTheme] = useState('default');
  const handleTheme = (t) => setTheme(t);

  const panelRef        = useRef(null);
  const dragStart       = useRef({ x: 0, y: 0 });
  const seqTimers       = useRef([]);
  const switchingRef    = useRef(false);
  const prevAppRef  = useRef('boot_main');

  // Launch a terminal app by name.
  // 'reboot' → always goes back to boot_main and remounts it.
  // Any registered terminal app name → fades out current, fades in new.
  const launchApp = (name) => {
    if (switchingRef.current) return;
    const target = name === 'reboot' ? 'boot_main' : name;
    prevAppRef.current = activeApp;
    switchingRef.current = true;
    setAppVisible(false);
    setTimeout(() => {
      setActiveApp(target);
      setAppInstance(i => i + 1); // force remount
      setAppVisible(true);
      switchingRef.current = false;
    }, 350);
  };

  const handleCommand = (cmd) => launchApp(cmd);

  const cancelSequence = () => {
    seqTimers.current.forEach(clearTimeout);
    seqTimers.current = [];
    setPhase('hidden');
    setVehicles([]);
    setIsReturning(false);
  };

  const triggerCenter = () => {
    if (phase !== 'hidden') return;
    cancelSequence();
    const effectivePos =
      (Math.abs(position.x) <= AXIS_THRESHOLD && Math.abs(position.y) <= AXIS_THRESHOLD)
        ? { x: -(AXIS_THRESHOLD + 1), y: 0 }
        : position;
    if (!panelRef.current) return;
    const rect = panelRef.current.getBoundingClientRect();
    const newVehicles = buildVehicles(effectivePos, rect);
    if (newVehicles.length === 0) return;
    setVehicles(newVehicles);
    setPhase('entering');
    const ARRIVE = DRIVE_DURATION + 300;
    const t1 = setTimeout(() => {
      setPhase('pushing');
      setIsReturning(true);
      setPosition({ x: 0, y: 0 });
    }, ARRIVE);
    const t2 = setTimeout(() => {
      setPhase('exiting');
    }, ARRIVE + PUSH_DURATION + 300);
    const t3 = setTimeout(() => {
      setPhase('hidden');
      setVehicles([]);
      setIsReturning(false);
    }, ARRIVE + PUSH_DURATION + 300 + DRIVE_DURATION);
    seqTimers.current = [t1, t2, t3];
  };

  const handleMouseDown = (e) => {
    cancelSequence();
    setIsDragging(true);
    dragStart.current = { x: e.clientX - position.x, y: e.clientY - position.y };
    e.preventDefault();
  };

  useEffect(() => {
    const onMove = (e) => {
      if (isDragging) setPosition({ x: e.clientX - dragStart.current.x, y: e.clientY - dragStart.current.y });
    };
    const onUp = () => setIsDragging(false);
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
    return () => { document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp); };
  }, [isDragging]);

  const { x: posX, y: posY } = position;

  useEffect(() => {
    if (isDragging) return;
    if (posX === 0 && posY === 0) return;

    const main = setTimeout(() => {
      if (!panelRef.current) return;
      const rect = panelRef.current.getBoundingClientRect();
      const newVehicles = buildVehicles({ x: posX, y: posY }, rect);
      if (newVehicles.length === 0) return;

      setVehicles(newVehicles);
      setPhase('entering');

      const ARRIVE = DRIVE_DURATION + 300;

      const t1 = setTimeout(() => {
        setPhase('pushing');
        setIsReturning(true);
        setPosition({ x: 0, y: 0 });
      }, ARRIVE);

      const t2 = setTimeout(() => {
        setPhase('exiting');
      }, ARRIVE + PUSH_DURATION + 300);

      const t3 = setTimeout(() => {
        setPhase('hidden');
        setVehicles([]);
        setIsReturning(false);
      }, ARRIVE + PUSH_DURATION + 300 + DRIVE_DURATION);

      seqTimers.current = [t1, t2, t3];
    }, 20000);

    return () => clearTimeout(main);
  }, [isDragging, posX, posY]);

  const AppComponent = TERMINAL_APP_COMPONENTS[activeApp] || BootMain;

  return (
    <section className="hero" id="home">
      <div className="hero-grid-bg" aria-hidden="true" />

      {phase !== 'hidden' && vehicles.map(v => (
        <Vehicle key={v.id} {...v} phase={phase} />
      ))}

      <div className="container">
        <div
          ref={panelRef}
          className={`hero-panel${isDragging ? ' hero-panel-dragging' : ''}${isReturning ? ' hero-panel-returning' : ''}${theme === 'ibm' ? ' theme-ibm' : ''}`}
          style={{ transform: `translate(${position.x}px, ${position.y}px)` }}
        >
          {/* Title bar — path updates to reflect active terminal app */}
          <div className="hero-panel-bar" onMouseDown={handleMouseDown}>
            <span
              className="hero-panel-dot hero-panel-dot-close"
              onClick={e => { e.stopPropagation(); handleCommand('reboot'); }}
              onMouseDown={e => e.stopPropagation()}
            />
            <span className="hero-panel-dot" />
            <span className="hero-panel-dot" />
            <span className="hero-panel-label">
              user@southlabs: {TERMINAL_APPS[activeApp].path}
            </span>
          </div>

          {/* Terminal app area — fades out/in on terminal app switch */}
          <div className="hero-content">
            <div style={{
              opacity:       appVisible ? 1 : 0,
              transition:    'opacity 0.35s ease',
              pointerEvents: appVisible ? 'auto' : 'none',
            }}>
              <AppComponent key={appInstance} onCommand={handleCommand} fast={appInstance > 0} prevApp={prevAppRef.current} onCenter={triggerCenter} onTheme={handleTheme} />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Hero;
